import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Col, Row, Table } from 'reactstrap';

import ActionCard from '../../../components/Footer/ActionCard';
import SuccessModal from '../../../components/Common/Modals/SuccessModal';
import UnsavedDataModal from '../../../components/Common/Modals/UnsavedDataModal';

import { UpdateEditRestriction } from '../../../store/action-restriction/actions';
import styles from './style.module.scss';

import { IValidStoreData, IValidStorePayload } from '../../../interfaces/valid-store.interface';
import { GetValidStoreData, UpdateValidStoreData, InitializeValidStore } from '../../../api-services/sales-plan.api';
import { GetPlanId } from '../../../helpers/Helpers';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isLoading: boolean;
  dataSource: any;
  originalDataSource: any;
  isModalOpened: boolean;
  initializeList: {
    label: string;
    value: string;
  }[];
  selectedInitialize: string;
}


class ValidStoreTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] },
      isModalOpened: false,
      initializeList: [
        { label: 'Initialize based on LY / Forecast', value: 'LY' },
        { label: 'Copy Valid Store from LQ', value: 'LQ' },
        { label: 'Initialize All', value: 'ALL' }
      ],
      selectedInitialize: ''
    };
  }

  componentDidMount(): void {
    this.getValidStoreData();
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.setState({
        isLoading: true
      }, () => {

        this.getValidStoreData();
      });
    }
  }

  getValidStoreData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    GetValidStoreData(params)
      .then((res: IValidStoreData) => {
        this.setState({
          originalDataSource: !!res ? res : { columns: [], rows: [] },
          isLoading: false
        }, () => {
          this.dataInit(true);
          this.props.onLoadEnd();
        });
        this.props.UpdateEditRestriction(false);
      });
  }

  dataInit(isNew: boolean): void {
    const data: IValidStoreData = JSON.parse(JSON.stringify(this.state.originalDataSource))//{...this.state.originalDataSource};
    const dataSource: IValidStoreData = {
      columns: data.columns.map((column) => {
        return {
          ...column
        };
      }),
      rows: data.rows.map((row, rIdx) => {
        return {
          ...row
        };
      })
    };

    this.setState({ dataSource })
  }

  updateStoreCalculation(
    rowArr,
    rowIdx: number,
    storeIdx: number,
    event
  ): void {
    //const value: any = event.target.value !== '' ? parseFloat(event.target.value) : '';
    const value: any = event.target.value !== '1' && event.target.value != '0' && event.target.value != '' ? ' ' : parseFloat(event.target.value)
    this.state.dataSource.rows[rowIdx].stores[storeIdx].value = value;
    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].stores[storeIdx].isEdited = true;

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateValidStoreData() {
    const payload: IValidStorePayload = { row: [] };
    payload.row = this.state.dataSource.rows.filter((row) => row.isEdited)
      .map((rowEle) => {
        return {
          product: rowEle.product,
          stores: rowEle.stores
            .filter((store) => store.isEdited)
        }
      });

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    UpdateValidStoreData(payload, params)
      .then((res) => {
        if (!!res) {
          this.props.onUpdateEnd();
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  initializeValidStore(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    InitializeValidStore(this.state.selectedInitialize, params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }

  render(): React.ReactNode {

    const bodySection = <div>
      <Card className="section-header-card">
        <Row>
          <Col md={6} className="align-self-center">

            <Row className="align-items-center">
              <Col md={4}>
                <div className="d-flex">
                  <p className="table-title">Valid Store
                  </p>
                </div>
              </Col>
              <Col md={6} className="align-self-center text-right">

                <div className="custom-form-container">
                  <label htmlFor={'initialize'} className="custom-form-label">Initialize</label>
                  <select
                    id="initialize"
                    style={{ width: '240px' }}
                    className="custom-drop-down-field custom-select-width"
                    onChange={(e) => {
                      this.setState({
                        selectedInitialize: e.target.value
                      }, () => {
                        ['LY', 'LQ', 'ALL'].indexOf(this.state.selectedInitialize) !== -1 &&
                        this.initializeValidStore();
                      });
                    }}
                  >
                    <option value="">Select</option>
                    {
                      this.state.initializeList.map((initialize, initializeIdx) => (
                        <option
                          key={initializeIdx}
                          value={initialize.value}
                        >
                          {initialize.label}
                        </option>
                      ))
                    }
                  </select>
                </div>
              </Col>
            </Row>
          </Col>

        </Row>
      </Card>

      <div className="table-responsive table-outline custom-table sticky-table">
        <Table className="mb-0">
          <thead className={`${styles['table-header']}`}>
          {
            this.state.dataSource.columns.map((row, rowIdx: number) => (
              <React.Fragment key={rowIdx}>
                <tr>
                  {
                    row.product.map((product, mIdx: number) => (
                      <React.Fragment key={mIdx}>
                        <th key={mIdx} className='dark-bg-cell' style={{ minWidth: '120px' }}>
              <span className="toggle-col">
                {product.value}
                </span>
                        </th>
                      </React.Fragment>
                    ))
                  }
                  {
                    row.stores.map((store, strIdx: number) => (
                      <React.Fragment key={strIdx}>
                        <th className='dark-bg-cell'>
                  <span className="toggle-col">
                  {store}
                </span>
                        </th>
                      </React.Fragment>
                    ))
                  }
                </tr>
              </React.Fragment>
            ))
          }
          </thead>

          <tbody>
          {
            this.state.dataSource.rows.map((row, rowIdx: number) => (
              <React.Fragment key={rowIdx}>
                <tr>
                  {
                    row.product.map((product, mIdx: number) => (
                      <React.Fragment key={mIdx}>
                        <td key={mIdx} style={{ minWidth: '120px' }}>
                <span className="toggle-col">
                {product.value}
                </span>
                        </td>
                      </React.Fragment>
                    ))
                  }
                  {
                    row.stores.map((store, strIdx: number) => (
                      <React.Fragment key={strIdx}>
                        <td>
                          {
                            <input
                              type="number"
                              className={
                                `${(store.isEdited)
                                  ? 'editable-input-new'
                                  : 'editable-input'}`
                              }
                              onChange={(e) => {
                                this.updateStoreCalculation(this.state.dataSource.rows, rowIdx, strIdx, e);
                              }}
                              value={store.value}
                            />
                          }
                        </td>
                      </React.Fragment>
                    ))
                  }
                </tr>
              </React.Fragment>
            ))
          }
          </tbody>
        </Table>
      </div>
    </div>

    return (
      <React.Fragment>
        {bodySection}
        <ActionCard
          onCancel={() => {
            this.dataInit(false);
            this.props.UpdateEditRestriction(false);
          }}
          onSave={() => {
            this.updateValidStoreData();
          }}
        />

        <SuccessModal
          isOpen={this.state.isModalOpened}
          toggle={() => this.setState({ isModalOpened: !this.state.isModalOpened })}
          message={'Data saved successfully !!!'}
        />

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(ValidStoreTable));
  